// import { mapGetters, mapMutations, mapActions } from 'vuex'
import { mapMutations } from 'vuex'
import { getToken } from '@/common/js/auth.js'
import storage from 'good-storage'
const USER = '__user__'

export const getUserMixin = {
  created () {
    if (storage.get(USER)) {
      this.setStoreUser(storage.get(USER))
    }
  },
  methods: {
    // ...mapActions(['saveSearchHistory', 'deleteSearchHistory'])
    ...mapMutations({
      setStoreUser: 'SET_USER'
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/js/mixin.js